module.exports = __webpack_public_path__ + "../resources/images/SkyCode_27-bd62c4e223e4106e5eef4a42ea517747.svg";